module.exports = __webpack_public_path__ + "static/img/ktb_phto@2x.253c749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/ktb_phto@2x.png
// module id = nuFA
// module chunks = 70